import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MoradorFacialPage } from './morador-facial.page';

const routes: Routes = [
  {
    path: '',
    component: MoradorFacialPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MoradorFacialPageRoutingModule {}
